import { bootstrap } from "vue-gtag";

export default {
  methods: {

    cookieReject() {
      return Promise.all([
        this.cookieRejectMicrosoft(),
        this.cookieRejectGoogle()
      ]);
    },

    cookieRejectGoogle() {
      return bootstrap()
        .then((gtag) => {
          this.$gtag.optOut();
        });
    },
    cookieRejectMicrosoft() {
      return new Promise((resolve, reject) => {
        try {
          window.uetq = window.uetq || [];
          window.uetq.push("consent", "update", {
            "ad_storage": "denied"
          });
          resolve();
        } catch (e) {
          console.error("Allgemeiner Fehler:", e);
          reject(e);
        }
      });
    },

    deleteCookie(cookieName) {
      const name = cookieName || "form_session";

      // 1) Server-side delete to handle HttpOnly cookies
      try {
        axios.post("/api/cookie/delete", { name }).catch(() => {
          // ignore network errors silently for this helper
        });
      } catch (e) {
        // no-op
      }

      // 2) Client-side fallback for non-HttpOnly cookies (best-effort)
      try {
        const expire = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
        const path = "path=/";

        // Current host
        document.cookie = `${name}=; ${expire}; ${path}`;

        // Try common parent-domain variant (e.g., remove dev./app.)
        const host = window.location.hostname || "";
        const base = host.replace(/^dev\./i, "").replace(/^app\./i, "");
        if (base && base !== host) {
          document.cookie = `${name}=; ${expire}; ${path}; domain=.${base}`;
        }
      } catch (e) {
        // ignore
      }
      document.cookie = "form_session= ; expires = Thu, 01 Jan 1970 00:00:00 GMT" + ";path=/;Secure";

    },

    async deleteCookieAsync(cookieName) {
      const name = cookieName || "form_session";

      // 1) Server-seitiges Löschen für HttpOnly-Cookies
      try {
        await axios.post("/api/cookie/delete", { name }).catch(() => {
          // Netzwerkfehler werden für diesen Helper ignoriert
        });
      } catch (e) {
        // keine Aktion
      }

      // 2) Client-seitiges Löschen für nicht-HttpOnly-Cookies (Best-Effort)
      try {
        const expire = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
        const path = "path=/";

        // Aktueller Host
        document.cookie = `${name}=; ${expire}; ${path}`;

        // Versuche gängige Parent-Domain-Variante (z.B. ohne dev./app.)
        const host = window.location.hostname || "";
        const base = host.replace(/^dev\./i, "").replace(/^app\./i, "");
        if (base && base !== host) {
          document.cookie = `${name}=; ${expire}; ${path}; domain=.${base}`;
        }
      } catch (e) {
        // ignorieren
      }
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure`;

    },

    cookieAccept() {

      // Init Google and Consent Mode für Microsoft UET
      try {
        window.uetq = window.uetq || [];
        window.uetq.push("consent", "update", {
          "ad_storage": "granted"
        });
      } catch (e) {
        console.error("Allgemeiner Fehler:", e);
      }

      // Init Google and Consent Mode für Google AdWords
      return new Promise((resolve, reject) => {
        try {
          bootstrap()
            .then((gtag) => {
              this.$gtag.optIn();
              this.$gtag.query("consent", "update", {
                ad_storage: "granted",
                analytics_storage: "granted",
                ad_user_data: "granted",
                ad_personalization: "granted",
                security_storage: "granted",
                personalization_storage: "granted",
                functionality_storage: "granted",
                wait_for_update: 500
              });
              resolve();
            })
            .catch((error) => {
              console.error("Fehler beim Bootstrap:", error);
              reject(error);
            });
        } catch (e) {
          console.error("Allgemeiner Fehler:", e);
          reject(e);
        }
      });


    },


    isAuth() {
      return $("meta[name=auth]").attr("content");
    },


    // Zeigt die helfen Informationen beim Eingabefeld an.
    showHelpTextField() {
      if (!this.isProduction()) {
        return 1;
      }
      return 0;
    },

    setSentryUser(customer) {
      Sentry.setUser({
        id: customer.id,
        email: customer.email
      });
    }
  }
};
